import api, { formatApiErrorDetail } from "../../lib/api";
import { Trash2, MapPin } from "lucide-react";
import { toast } from "sonner";

export function PropertyList({ items, onChanged }) {
  const remove = async (id) => {
    if (!window.confirm("Delete this property?")) return;
    try {
      await api.delete(`/properties/${id}`);
      toast.success("Property deleted");
      onChanged();
    } catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
  };
  if (items.length === 0) {
    return <div className="p-12 text-center text-slate-500" data-testid="properties-empty">No properties yet. Add your first one.</div>;
  }
  return (
    <table className="w-full min-w-[640px]">
      <thead className="bg-slate-50">
        <tr className="text-left text-xs uppercase tracking-wider text-slate-500 border-b border-slate-200">
          <th className="px-6 py-3">Name</th><th className="px-6 py-3">Type</th>
          <th className="px-6 py-3">Location</th><th className="px-6 py-3">Rooms</th><th className="px-6 py-3"></th>
        </tr>
      </thead>
      <tbody>
        {items.map((p) => (
          <tr key={p.id} className="border-b border-slate-100 hover:bg-slate-50" data-testid={`prop-row-${p.id}`}>
            <td className="px-6 py-4 font-medium">{p.name}</td>
            <td className="px-6 py-4"><span className="bg-blue-50 border border-blue-100 text-blue-700 px-2 py-0.5 text-xs">{p.type}</span></td>
            <td className="px-6 py-4 text-sm text-slate-600"><span className="inline-flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5" />{[p.address, p.city].filter(Boolean).join(", ")}</span></td>
            <td className="px-6 py-4">{p.total_rooms}</td>
            <td className="px-6 py-4 text-right">
              <button onClick={() => remove(p.id)} data-testid={`prop-delete-${p.id}`}
                      className="text-red-600 hover:bg-red-50 p-2"><Trash2 className="h-4 w-4" /></button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
